import './installation.reducer';
import * as actions from './installation.actions';
import * as selectors from './installation.selectors';

export {
	actions,
	selectors
};
